<script setup lang="ts" name="NoPermission">
import { useRouter } from 'vue-router'
import { WarningFilled } from '@element-plus/icons-vue'
import { ArrowLeftOutlined } from '@ant-design/icons-vue'

const router = useRouter()
</script>

<template>
  <div class="py-36 flex items-center justify-center bg-gray-50">
    <div class="text-center">
      <!-- 403图标 -->
      <el-icon size="80">
        <WarningFilled class="text-error" />
      </el-icon>

      <!-- 标题 -->
      <h1 class="text-4xl font-bold text-n-800 mb-4">
        访问受限
      </h1>

      <!-- 提示文本 -->
      <p class="text-lg text-n-90 mb-8">
        抱歉，您没有访问该页面的权限
      </p>

      <!-- 返回按钮 -->
      <el-button type="primary" bg text :icon="ArrowLeftOutlined" @click="router.back()">
        返回上一级
      </el-button>
      <el-button type="primary" @click="router.replace({ name: 'DashboardIndex' })">
        返回首页
      </el-button>
    </div>
  </div>
</template>
